// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "bootstrap" + "." + "8e57de4fc51772ae0da2" + ".css";
};